import React, { FC, useEffect } from 'react';
import {
  ThemeOverride,
  ThemeSurface,
} from '@wix/da-react-context/pkg/ThemeContext';
import ModalLayout from '@wix/da-ds/pkg/modals/dsPresets/Modal/ModalLayout';
import { ModalRoot } from '@wix/da-ds/pkg/modals/base';
import { Editor } from '@tiptap/react';

import s from './SidePanel.scss';

export interface Props {
  header: React.ReactNode;
  footer: React.ReactNode;
  children?: React.ReactNode;
  onRequestClose?: (event: React.MouseEvent | React.KeyboardEvent) => void;
  editor: Editor;
}

const SidePanel: FC<Props> = ({
  header,
  footer,
  children,
  onRequestClose,
  editor,
}) => {
  // Allow scrolling so editor can scroll when the panel is open
  useEffect(() => {
    if (editor.storage['da-inside-modal'] !== true) {
      document.body.style.overflowY = 'scroll';
    }
    return () => {
      if (editor.storage['da-inside-modal'] !== true) {
        document.body.style.overflowY = 'auto';
      }
    };
  }, [editor.storage]);

  return (
    <ThemeOverride themeSurface={ThemeSurface.TERTIARY}>
      <ModalRoot
        isOpen={true}
        className={s['panel-modal']}
        useTransparentOverlay
        onRequestClose={onRequestClose}
        useFixedMobileHeight
        shouldCloseOnOverlayClick={false}
        bodyScrollLockOptions={{
          allowTouchMove: (el: HTMLElement) => {
            // Slider
            // Inputs like ranges
            return (
              el.closest('.menu-scrollable') !== null ||
              el.tagName === 'INPUT' ||
              el.closest('input') !== null
            );
          },
        }}
      >
        <ModalLayout
          className={s['container']}
          header={header}
          headerBorder
          content={children}
          contentClassName={s['modal-content']}
          footerBorder
          footer={<div className={s['footer']}>{footer}</div>}
        />
      </ModalRoot>
    </ThemeOverride>
  );
};
SidePanel.displayName = 'SidePanel';

export default SidePanel;
